export default "//cloud.imgsmail.ru/cloud.mail.ru/106876/img/build/promocodePopup.jpg";